import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { TwoParticipantsSportsTabState } from './TwoParticipantsSportsTabState';
import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';

export interface MarketTemplatesType {
    id: string;
    marketName: string;
    line: number | null;
}

export type MarketTemplatesRecordType = Record<string, MarketTemplatesType>;
const defaultMarketId = 'match-winner';

export const footballMarketsConfig: Array<MarketTemplatesType> = [
    {
        id: defaultMarketId,
        marketName: 'Match Result',
        line: null,
    },
    {
        id: 'both-teams-to-score',
        marketName: 'Both Teams To Score',
        line: null,
    },
    {
        id: 'total-goals-over-under',
        marketName: 'Over/Under 2.5 Goals',
        line: 2.5,
    },
    {
        id: 'draw-no-bet',
        marketName: 'Draw No Bet',
        line: null,
    },
    {
        id: '1st-half-winner',
        marketName: 'First Half Result',
        line: null,
    },
];

const getDefaultMarketTemplate = (marketTemplates: MarketTemplatesRecordType): MarketTemplatesType | undefined => {
    for (const item of Object.values(marketTemplates)) {
        if (item.id === defaultMarketId) {
            return item;
        }
    }

    for (const item of Object.values(marketTemplates)) {
        return item;
    }
};

export const marketTemplate = (
    sportState: TwoParticipantsSportsTabState,
    marketTemplates: MarketTemplatesRecordType
): MarketTemplatesType | undefined => {
    if (sportState.currentSport === 'football') {
        if (sportState.currentMarket === null) {
            return footballMarketsConfig.find((market) => market.id === defaultMarketId);
        } else {
            return footballMarketsConfig.find((market) => market.id === sportState.currentMarket);
        }
    } else {
        return getDefaultMarketTemplate(marketTemplates);
    }
};

export const findMarket = (
    event: EventListGroupEventItemType | undefined,
    sportState: TwoParticipantsSportsTabState,
    marketTemplates: MarketTemplatesRecordType
): EventMarketItemType | undefined => {
    const marketTemplateForRow = marketTemplate(sportState, marketTemplates);

    const market = event?.id2.getEventMarkets()?.find((market) => {
        if (market.templateId === marketTemplateForRow?.id) {
            const marketLine = marketTemplateForRow.line;
            if (marketLine === null || marketLine === undefined) {
                return market;
            } else {
                return market.id2.getModel()?.line === marketLine;
            }
        }
    });
    return market;
};
